export default __webpack_public_path__ + "static/media/trampapo_02_16.8038f4ac.jpg";